import { z } from 'zod';
export const actionPreviewBlockSchema = z.object({
    type: z.literal('action_preview'),
    id: z.string(),
    label: z.string(),
    draft: z.record(z.unknown()),
    status: z.enum(['pending', 'applied', 'discarded']),
});
export const dataResultBlockSchema = z.object({
    type: z.literal('data_result'),
    id: z.string(),
    columns: z.array(z.string()),
    rows: z.array(z.record(z.unknown())),
    totalCount: z.number().optional(),
});
export const recordEmbedBlockSchema = z.object({
    type: z.literal('record_embed'),
    id: z.string(),
    recordId: z.string(),
    recordType: z.string(),
    fields: z.record(z.unknown()),
    editable: z.boolean(),
});
export const bulkEditRowSchema = z.object({
    id: z.string(),
    fields: z.record(z.unknown()),
    status: z.enum(['pending', 'approved', 'denied']),
});
export const bulkEditBlockSchema = z.object({
    type: z.literal('bulk_edit'),
    id: z.string(),
    rows: z.array(bulkEditRowSchema),
    totalCount: z.number(),
});
export const reasoningTraceBlockSchema = z.object({
    type: z.literal('reasoning_trace'),
    id: z.string(),
    content: z.string(),
    collapsed: z.boolean(),
});
export const approvalRequiredBlockSchema = z.object({
    type: z.literal('approval_required'),
    id: z.string(),
    actionId: z.string(),
    description: z.string(),
    status: z.enum(['pending', 'approved', 'denied']),
});
export const citationPillBlockSchema = z.object({
    type: z.literal('citation_pill'),
    id: z.string(),
    recordId: z.string(),
    recordType: z.string(),
    label: z.string(),
});
export const messageBlockSchema = z.discriminatedUnion('type', [
    actionPreviewBlockSchema,
    dataResultBlockSchema,
    recordEmbedBlockSchema,
    bulkEditBlockSchema,
    reasoningTraceBlockSchema,
    approvalRequiredBlockSchema,
    citationPillBlockSchema,
]);
//# sourceMappingURL=blocks.js.map